import React from 'react';
import { inject } from 'mobx-react';
import { MarketplaceOrderEditAssignmentStepTemplate } from 'themes/modules/order/pages/wizard';

@inject(i => ({
	marketplaceOrderEditViewStore: i.rootStore.marketplaceOrderEditViewStore,
}))
class MarketplaceOrderEditAssignmentStep extends React.Component {
	render() {
		return <MarketplaceOrderEditAssignmentStepTemplate {...this.props} />;
	}
}

export default MarketplaceOrderEditAssignmentStep;



// WEBPACK FOOTER //
// ./src/modules/order/pages/wizard/MarketplaceOrderEditAssignmentStep.jsx